import type { CostValues } from './CostEdit';
import type { PlaceChange } from '../../lib/variantEdit';

/** A stay's costs changed: whichever of its ranges were edited. */
export function stayChange({ ranges }: CostValues): PlaceChange {
  const { estimate, ...stay } = ranges;
  return estimate ? {} : stay;
}

/** A way changed: its price, its times and its link, and the ticket in mind when said. */
function wayOf({ ranges, kept, name, link }: CostValues, named: boolean) {
  return ranges.estimate
    ? {
        estimate: ranges.estimate,
        departureAt: kept?.departureAt ?? null,
        arrivalAt: kept?.arrivalAt ?? null,
        link,
        ...(named ? { name } : {}),
      }
    : null;
}

/** The way on of a stop of the plan changed. */
export function wayOnChange(values: CostValues): PlaceChange {
  const way = wayOf(values, false);
  return way ? { way } : {};
}

/** The way on of a variant's place changed: also the ticket in mind. */
export function ticketChange(values: CostValues): PlaceChange {
  const way = wayOf(values, true);
  return way ? { way } : {};
}

/** The way to a variant's place changed: also the ticket in mind. */
export function wayInChange(values: CostValues): PlaceChange {
  const wayIn = wayOf(values, true);
  return wayIn ? { wayIn } : {};
}
